import SelectDonation from '@piconetworks/select-donation'
import withInjection from '@piconetworks/with-injection'

import Loader from 'common/modules/loader'

import { Link } from '@piconetworks/router-adapter'
import WizardRedux from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => {
    const defaultPopup = Loader.selectors.getDefaultPopup(state)
    return {
        ...props,
        getPlanTexts: (scope) => Loader.selectors.planTexts(state, scope, defaultPopup),
        featureList: (scope) => Loader.selectors.featureList(state, scope),
        userLoader: state.loader.user,
        guestLoader: state.loader.guest,
        Link,
        WizardRedux,
    }
}

const InjectedSelectDonation = withInjection(SelectDonation, {
    mapStateToProps,
})

export default InjectedSelectDonation
